<template>
    <div class="hs-container">
        <div class="order-search-box">
            <div class="search-left">
                <el-select v-model="query.company_id" filterable collapse-tags clearable placeholder="选择公司" class="handle-select mr10 w7rem" style="width:11.5rem;">
                    <el-option v-for="(row,index) in companyList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>
                <el-select v-model="query.hotel_id" filterable multiple collapse-tags clearable placeholder="选择酒店" class="popover-left popover-wid mr10">
                    <el-option v-for="(row,index) in hotelList" :key="index" :label="row.title" :value="row.id"></el-option>
                </el-select>

                <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange" align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
            </div>
        </div>

        <el-table id="out-table" :data="tableData" :height="height" border class="table" ref="multipleTable" header-cell-class-name="table-header" :default-sort="{prop:'sign_date'}" :show-summary="true" :summary-method="getSummaries" v-loading="loading">
            <el-table-column type="index" width="60" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="contract_no" label="合同号" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="company" label="承办公司" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="event_date" label="婚期" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="hotel" label="酒店" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="bridegroom" label="客户姓名" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="totals" label="合同总价" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="策划师" align="center" width="160" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <el-link type="primary" v-for="(item,index) in scope.row.planner" :key="index">{{item.realname}}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="suborder" label="二销" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="compere" label="司仪" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="makeup" label="化妆" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="camera" label="摄像" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="shoot" label="摄影" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="sugar" label="喜糖" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="dessert" label="点心" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="light" label="灯光" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="balloon" label="气球" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="act" label="演绎" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="wine" label="酒水" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="led" label="LED" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="t_platform" label="T台" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="truss" label="桁架" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="design" label="板材" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="flower_teacher" label="花艺师" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="flower_false" label="仿真花" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="labor_cost" label="人工费" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="transport_charge" label="运输费" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="garbage_cost" label="清理垃圾费" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="meal_cost" label="外叫餐费" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>

        </el-table>
    </div>
</template>

<script>
import fileSaver from 'file-saver';
import xlsx from 'xlsx';
import dictionary from '@/utils/dictionary.js';

let query = {
    hotel_id: '',
    company_id: '',
    date_range: []
};
export default {
    data() {
        let accountPickerList = dictionary.getPicker('account');
        return {
            loading: false,
            sumFields: ['totals'],
            height: window.innerHeight * 0.75,
            tableData: [],
            query: Object.assign({}, query),
            companyList: [],
            hotelList: [],
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    created() {
        // 获取picker
        this.getPicker();
    },
    updated() {
        this.$refs.multipleTable.doLayout() //vue 在el-table中同时使用summary-method 不展示的问题
    },
    methods: {
        getTableData() {
            let that = this;
            let url = '/api/statistics.supplier/index';
            that.loading = true;
            this.$post(url, this.query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.loading = false;
            });
        },
        // 重置
        resetFn() {
            this.query = Object.assign({}, query);
        },
        // 触发搜索按钮
        handleSearch() {
            let _this = this;
            if (_this.query.date_range == "") {
                this.$message.error('请选择婚期');
                return false
            }
            _this.getTableData();
        },
        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 获取Picker
        getPicker() {
            let url = '/api/statistics.picker/items';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.companyList = response.data.companyList;
                that.hotelList = response.data.hotelList;
            });
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#out-table'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    'sheetjs.xlsx'
                );
            } catch (e) { }
            return wbout;
        },
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总价';
                    return;
                }

                if (this.sumFields.indexOf(column.property) < 0) {
                    sums[index] = '';
                    return;
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    let sum = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);

                    sums[index] = sum.toFixed(2);
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        }
    }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/order.less');
@import url('@/assets/css/member.less');

.top-search {
    width: 100%;
    padding: 20px 0;
    box-sizing: border-box;
}

.search-left {
    .daterange {
        width: 13rem !important;
    }
}
</style>
